import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  // Filter out errors that only happen when a user on a stale bundle navigates to a route
  // whose chunk has been removed by a new deploy. We already handle these by listening to
  // `vite:preloadError` in `entry.client.tsx` and reloading the page, so they're expected
  // noise, not actionable bugs. https://docs.sentry.io/platforms/javascript/configuration/filtering/
  ignoreErrors: [
    // Vite preload helper failures (stale chunk after deploy).
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    // React's `lazy` throws this when the preload helper resolves undefined. Kept as a
    // belt-and-suspenders filter in case a code path still ends up there.
    /Cannot read properties of undefined \(reading 'default'\)/i,
  ],
});
